module.exports = ".bgm-red{\n    background-color:#ad1115!important\n  }\n  .c-red{\n    color:#ad1115!important\n  }\n  .card-stadium-body img {\n    max-width: 100%;\n  }\n  .author-date{\n    color: #FFF;\n    font-size:15px\n  }\n  .title{\n    font-size:25px;\n    line-height:100%;\n    color:#fff\n  }\n  .card-stadium{\n      padding: 10px 30px;\n  }\n  .clear {\n      clear: both;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/news/feed-card/feed-card.component.css
// module id = ./src/app/components/news/feed-card/feed-card.component.css
// module chunks = main